import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { XCircle, ArrowRight, ArrowLeft } from 'lucide-react'
import { Button } from '../../components/ui/Button'
import { Card } from '../../components/ui/Card'
import { Navigation } from '../../components/Navigation'

export const CheckoutCanceled: React.FC = () => {
  return (
    <div className="min-h-screen bg-calming">
      <Navigation variant="dashboard" />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Card className="p-8 text-center">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-10 h-10 text-amber-600" />
            </div>
            
            <h1 className="text-3xl font-bold text-slate-900 mb-4">
              Checkout Canceled
            </h1>
            
            <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
              Your payment process was canceled. No charges have been made to your account.
            </p>
            
            <div className="bg-slate-50 rounded-lg p-6 mb-8 text-left">
              <h3 className="text-lg font-semibold text-slate-900 mb-4">What happens next?</h3>
              
              <ul className="space-y-3">
                <li className="flex items-start">
                  <div className="w-6 h-6 bg-slate-200 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                    <span className="text-sm font-medium text-slate-600">1</span>
                  </div>
                  <p className="text-slate-600">
                    You can try again whenever you're ready by visiting the subscription page.
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="w-6 h-6 bg-slate-200 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                    <span className="text-sm font-medium text-slate-600">2</span>
                  </div>
                  <p className="text-slate-600">
                    You'll continue to have access to your current plan features.
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="w-6 h-6 bg-slate-200 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                    <span className="text-sm font-medium text-slate-600">3</span>
                  </div>
                  <p className="text-slate-600">
                    If you encountered any issues during checkout, our support team is here to help.
                  </p>
                </li>
              </ul>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/settings?tab=subscription">
                <Button className="bg-sage-600 hover:bg-sage-700 text-white px-8">
                  Try Again
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
              
              <Link to="/dashboard">
                <Button variant="outline" className="border-slate-300 text-slate-700 hover:bg-slate-50 px-8">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Back to Dashboard
                </Button>
              </Link>
            </div>
          </Card>
          
          <div className="mt-8 text-center text-sm text-slate-500">
            <p>
              Need help with your subscription? Contact our support team at{' '}
              <a href="mailto:support@mentra.com" className="text-sage-600 hover:underline">
                support@mentra.com
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  )
}